import React from 'react';
// Components
import NewsletterForm from '../forms/NewsletterForm';

function NewsletterSignUpPageMainContainer() {
  return (
    <main role='main' className='grid w-full h-full pb-12 pt-24'>
      {/* Form section */}
      <section className='grid w-full'>
        <div className='grid w-full px-6 lg:container lg:mx-auto my-auto'>
          {/* About */}
          <section>
            <article className='max-w-2xl mx-auto text-center py-8'>
              <h1 className='text-4xl font-newsweekly mb-4 tracking-wider'>
                Enter My Inner Circle
              </h1>
              <p className='text-lg mb-4 font-poppins'>
                You’ve admired from afar—now take the next step.
              </p>
              <p className='text-base font-poppins'>
                Subscribe to my private newsletter and be the first to receive
                hand-picked updates, behind-the-scenes temptations, and
                exclusive invitations reserved only for the truly devoted.
                Whether you're in Norway or simply enchanted by my world, this
                is your gateway to something deeper.
              </p>
              <p className='text-base mt-4 font-poppins'>
                I don't send often. But when I do—it's unforgettable.
              </p>
            </article>
          </section>

          {/* Form */}
          <section className='grid border-[1px] h-fit border-colour4 border-solid rounded-xl shadow-2xl w-full bg-colour1 max-w-2xl mx-auto'>
            <div className='grid gap-4 w-full h-full px-8 py-6'>
              {/* Contact form */}
              <section>
                <NewsletterForm />
              </section>
            </div>
          </section>
        </div>
      </section>
    </main>
  );
}

export default NewsletterSignUpPageMainContainer;
